<template lang="pug">
.list_item
  .content.d-flex.flex-column.flex-md-row.align-items-center.align-items-md-start
    .img(v-if="info", :style="{ backgroundImage: 'url(' + info.Image + ')' }")
    .content
      p.i_body_l.i_mt_2 活動日期：{{ info.PostDate }}
      p.i_body_l.i_mt_2 活動標題：{{ info.Title }}
      p.i_body_l.i_mt_2 活動類別：{{ getType(info.Type) }}
      p.i_body_l.i_mt_2 簡述：{{ info.Brief }}
  .see_more_btn(@click="toDetailPage(info.ID)") 看更多
</template>

<script>
export default {
  name: "ListItem",
  props: {
    info: Object,
  },
  methods: {
    getType(type) {
    switch (String(type)) {
       case "0": return "社團活動";
       case "1": return "公司活動";
       case "2": return "轄區活動";
       case "3": return "跨部門活動";
       default:  return "";
      }
    },
    toDetailPage(id) {
      this.$router.push({
        name: "Detail",
        query: { type: "employeeCareNews", id: id },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/about_us/social_responsibility/list_item";
</style>
